/* 🤖 this file was generated by svg-to-ts */
export const matIconViewKanban: {
  name: 'view-kanban';
  data: string;
} = {
  name: 'view-kanban',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 7h2v10H7zm4 0h2v5h-2zm4 0h2v8h-2z"/><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/></svg>`
};
